"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { SelectItem as t, SelectItemText as n } from "../../atoms/Select/Select.mjs";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/molecules/SelectInput/SelectInputItem.tsx
var i = ({ className: i, children: a, ...o }) => /* @__PURE__ */ r(t, {
	className: e("dark:bg-neutral-dark-200 dark:hover:bg-neutral-dark-400 dark:text-neutral-dark-1000 dark:data-[state=checked]:bg-neutral-dark-400 dark:focus:bg-neutral-dark-400", i),
	...o,
	children: /* @__PURE__ */ r(n, { children: a })
});
//#endregion
export { i as SelectInputItem };
